import React, { useMemo } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { FaInfoCircle } from 'react-icons/fa';
import { useToast } from '../../../components/ui/ToastProvider';
import { deriveParcelSummary } from '../utils/parcelDisplay';
import './ParcelInfoRequestModal.css';

export function ParcelInfoRequestModal({ show, onHide, parcel }) {
  const { show: showToast } = useToast();
  const derived = useMemo(() => deriveParcelSummary(parcel), [parcel]);

  if (!parcel) return null;

  const handleCopyLink = async () => {
    try {
      const p = (parcel && parcel.properties) ? parcel.properties : {};
      const params = new URLSearchParams();
      const pid = p.lrid || p.parcelid || p.parcel_id || derived.parcelId;
      if (pid && pid !== 'Unknown') params.set('parcel_id', String(pid));
      try {
        const g = parcel && parcel.geometry;
        if (g && Array.isArray(g.coordinates)) {
          let minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;
          const walk = (arr) => {
            for (const item of arr) {
              if (Array.isArray(item) && typeof item[0] === 'number' && typeof item[1] === 'number') {
                const x = item[0], y = item[1];
                if (x < minX) minX = x; if (y < minY) minY = y;
                if (x > maxX) maxX = x; if (y > maxY) maxY = y;
              } else if (Array.isArray(item)) {
                walk(item);
              }
            }
          };
          walk(g.coordinates);
          if (minX !== Infinity) {
            params.set('parcel_bbox', [minX, minY, maxX, maxY].join(','));
          }
        }
      } catch (_) {}
      const url = `${window.location.origin}/maps${params.toString() ? `?${params.toString()}` : ''}`;
      await navigator?.clipboard?.writeText?.(url);
      try { showToast && showToast({ title: 'Copied', body: 'Parcel link copied to clipboard', variant: 'success' }); } catch (_) {}
    } catch (_) {
      try { showToast && showToast({ title: 'Copy failed', body: 'Unable to copy parcel link', variant: 'danger' }); } catch (_) {}
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered className="parcel-info-dialog">
      <Modal.Header closeButton>
        <Modal.Title className="d-flex align-items-center gap-2">
          <FaInfoCircle className="parcel-info-dialog__icon" />
          Parcel
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {(derived.owner || derived.ownerType || derived.mailing || derived.apn || derived.address || derived.county || derived.gisAcresLabel) && (
          <div className="mb-2">
            {derived.owner && (<div><strong>Owner</strong>: {derived.owner}</div>)}
            {derived.ownerType && (<div><strong>Owner type</strong>: {derived.ownerType}</div>)}
            {derived.mailing && (<div><strong>Mailing</strong>: {derived.mailing}</div>)}
            {derived.apn && (<div><strong>APN</strong>: {derived.apn}</div>)}
            {derived.address && (<div><strong>Situs</strong>: {derived.address}</div>)}
            {derived.county && (<div><strong>County</strong>: {derived.county}</div>)}
            {derived.gisAcresLabel && (<div><strong>GIS acres</strong>: {derived.gisAcresLabel}</div>)}
          </div>
        )}
        <p className="text-muted mb-0">
          Parcel boundaries: Land Records (landrecords.us). Not a survey.
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="outline-secondary" onClick={handleCopyLink}>
          Copy Parcel Link
        </Button>
        <Button variant="primary" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
